import React from "react";

export default function CardTitle({ className, ...otherProps }) {
  const classNames = ["card-title", className].join(" ");
  return <span {...otherProps} className={classNames} />;
}
